import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Upload, FileText, Pill, Store, Truck, CheckCircle2, MapPin } from 'lucide-react';
import { mockPrescriptions, mockPharmacies } from '../../data/mockData';
export function RefillMedsFlow() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [pharmacy, setPharmacy] = useState<string | null>(null);
  const [delivery, setDelivery] = useState('home');
  const [trackingState, setTrackingState] = useState(0);
  const prescription = mockPrescriptions[0];
  const handlePayment = () => {
    setStep(6);
    const t1 = setTimeout(() => setTrackingState(1), 2000);
    const t2 = setTimeout(() => setTrackingState(2), 4000);
    const t3 = setTimeout(() => setTrackingState(3), 6000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  };
  return <div className="min-h-screen bg-slate-50 flex flex-col" data-id="element-751">
      <div className="bg-white px-6 pt-12 pb-4 shadow-sm sticky top-0 z-10" data-id="element-752">
        <div className="flex items-center gap-3 mb-4" data-id="element-753">
          <button onClick={() => step > 1 && step < 6 ? setStep(step - 1) : navigate(-1)} className="p-2 -ml-2 hover:bg-slate-50 rounded-full" data-id="element-754">
            <ArrowLeft className="w-6 h-6 text-slate-700" data-id="element-755" />
          </button>
          <h1 className="text-xl font-bold text-slate-900" data-id="element-756">
            Refill Medications
          </h1>
        </div>
        {step < 6 && <div className="flex gap-2" data-id="element-757">
            {[1, 2, 3, 4, 5].map(i => <div key={i} className={`h-1.5 flex-1 rounded-full ${i <= step ? 'bg-orange-500' : 'bg-slate-200'}`} data-id="element-758" />)}
          </div>}
      </div>

      <div className="p-6 flex-1 overflow-y-auto" data-id="element-759">
        {step === 1 && <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-6" data-id="element-760">
            <button className="w-full py-8 bg-white border-2 border-slate-200 border-dashed rounded-xl flex flex-col items-center gap-2 text-slate-500 hover:bg-slate-50 hover:border-orange-300 transition-colors" data-id="element-761">
              <Upload className="w-8 h-8 text-slate-400" data-id="element-762" />
              <span className="text-sm font-medium" data-id="element-763">
                Upload New Prescription
              </span>
            </button>

            <div data-id="element-764">
              <h3 className="font-semibold text-slate-900 mb-3" data-id="element-765">
                Or Select Past Prescription
              </h3>
              <button onClick={() => setStep(2)} className="w-full bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex items-center justify-between hover:border-orange-200" data-id="element-766">
                <div className="flex items-center gap-3" data-id="element-767">
                  <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-768">
                    <FileText className="w-5 h-5 text-orange-600" data-id="element-769" />
                  </div>
                  <div className="text-left" data-id="element-770">
                    <p className="font-bold text-slate-900" data-id="element-771">
                      {prescription.doctorName}
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-772">
                      {prescription.date}
                    </p>
                  </div>
                </div>
              </button>
            </div>
          </motion.div>}

        {step === 2 && <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-4" data-id="element-773">
            <h2 className="font-semibold text-slate-900 mb-2" data-id="element-774">
              Select Medications
            </h2>
            <div className="space-y-3" data-id="element-775">
              {prescription.medications.map((med, idx) => <label key={idx} className="flex items-start gap-3 p-4 rounded-xl border border-orange-500 bg-orange-50 cursor-pointer" data-id="element-776">
                  <input type="checkbox" defaultChecked className="mt-1 w-5 h-5 rounded border-slate-300 text-orange-500 focus:ring-orange-500" data-id="element-777" />
                  <div data-id="element-778">
                    <h3 className="font-bold text-slate-900" data-id="element-779">
                      {med.name}{' '}
                      <span className="text-sm font-normal text-slate-500" data-id="element-780">
                        ({med.dosage})
                      </span>
                    </h3>
                    <p className="text-sm text-slate-600" data-id="element-781">{med.frequency}</p>
                  </div>
                </label>)}
            </div>
            <button onClick={() => setStep(3)} className="w-full bg-orange-500 text-white py-3.5 rounded-xl font-semibold text-lg shadow-sm mt-6" data-id="element-782">
              Continue
            </button>
          </motion.div>}

        {step === 3 && <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-4" data-id="element-783">
            <h2 className="font-semibold text-slate-900 mb-2" data-id="element-784">
              Choose Pharmacy
            </h2>
            <div className="space-y-3" data-id="element-785">
              {mockPharmacies.map(pharm => <button key={pharm.id} onClick={() => {
            setPharmacy(pharm.id);
            setStep(4);
          }} className="w-full bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex items-center justify-between hover:border-orange-200" data-id="element-786">
                  <div className="flex items-center gap-3" data-id="element-787">
                    <Store className="w-6 h-6 text-slate-400" data-id="element-788" />
                    <div className="text-left" data-id="element-789">
                      <p className="font-bold text-slate-900" data-id="element-790">{pharm.name}</p>
                      <p className="text-xs text-slate-500" data-id="element-791">{pharm.distance}</p>
                    </div>
                  </div>
                </button>)}
            </div>
          </motion.div>}

        {step === 4 && <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-6" data-id="element-792">
            <h2 className="font-semibold text-slate-900 mb-2" data-id="element-793">
              Delivery Method
            </h2>
            <div className="grid grid-cols-2 gap-3" data-id="element-794">
              <button onClick={() => setDelivery('home')} className={`p-4 rounded-xl border-2 flex flex-col items-center gap-2 ${delivery === 'home' ? 'border-orange-500 bg-orange-50 text-orange-700' : 'border-slate-200 bg-white'}`} data-id="element-795">
                <Truck className="w-6 h-6" data-id="element-796" />
                <span className="text-sm font-medium" data-id="element-797">Home Delivery</span>
              </button>
              <button onClick={() => setDelivery('pickup')} className={`p-4 rounded-xl border-2 flex flex-col items-center gap-2 ${delivery === 'pickup' ? 'border-orange-500 bg-orange-50 text-orange-700' : 'border-slate-200 bg-white'}`} data-id="element-798">
                <Store className="w-6 h-6" data-id="element-799" />
                <span className="text-sm font-medium" data-id="element-800">Pickup</span>
              </button>
            </div>
            <button onClick={() => setStep(5)} className="w-full bg-orange-500 text-white py-3.5 rounded-xl font-semibold text-lg shadow-sm" data-id="element-801">
              Continue to Summary
            </button>
          </motion.div>}

        {step === 5 && <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-6" data-id="element-802">
            <h2 className="text-xl font-bold text-slate-900" data-id="element-803">
              Payment Summary
            </h2>
            <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4 space-y-3" data-id="element-804">
              <div className="flex justify-between text-sm" data-id="element-805">
                <span className="text-slate-500" data-id="element-806">Medications (2)</span>
                <span className="font-medium" data-id="element-807">₦4,500</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-808">
                <span className="text-slate-500" data-id="element-809">Delivery Fee</span>
                <span className="font-medium" data-id="element-810">₦1,500</span>
              </div>
              <div className="pt-3 border-t border-slate-100 flex justify-between font-bold text-lg" data-id="element-811">
                <span data-id="element-812">Total</span>
                <span className="text-orange-600" data-id="element-813">₦6,000</span>
              </div>
            </div>
            <button onClick={handlePayment} className="w-full bg-orange-500 text-white py-3.5 rounded-xl font-semibold text-lg shadow-sm" data-id="element-814">
              Pay Securely
            </button>
          </motion.div>}

        {step === 6 && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="space-y-6" data-id="element-815">
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5" data-id="element-816">
              <h3 className="font-bold text-slate-900 mb-6 text-center" data-id="element-817">
                Order Status
              </h3>
              <div className="space-y-6 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px before:h-full before:w-0.5 before:bg-slate-200" data-id="element-818">
                {['Order Confirmed', 'Preparing', 'Out for Delivery', 'Delivered'].map((status, idx) => <div key={status} className="relative flex items-center gap-4" data-id="element-819">
                    <div className={`w-10 h-10 rounded-full border-4 border-white flex items-center justify-center z-10 transition-colors duration-500 ${trackingState >= idx ? 'bg-orange-500 text-white' : 'bg-slate-200 text-slate-400'}`} data-id="element-820">
                      <CheckCircle2 className="w-5 h-5" data-id="element-821" />
                    </div>
                    <span className={`font-medium ${trackingState >= idx ? 'text-slate-900' : 'text-slate-400'}`} data-id="element-822">
                      {status}
                    </span>
                  </div>)}
              </div>
            </div>
            {trackingState >= 2 && <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-white p-4 rounded-xl border border-slate-100 shadow-sm flex items-center gap-4" data-id="element-823">
                <div className="w-12 h-12 bg-slate-200 rounded-full" data-id="element-824" />
                <div data-id="element-825">
                  <p className="font-bold text-slate-900" data-id="element-826">John (Rider)</p>
                  <p className="text-sm text-slate-500" data-id="element-827">Arriving in 10 mins</p>
                </div>
              </motion.div>}
          </motion.div>}
      </div>
    </div>;
}